module.exports = __webpack_public_path__ + "static/media/tex_7902.8b78b132.jpeg";